import {
  Alert,
  schAlertSeverity,
  schAlertStatus,
  schAlertType,
  schPairedCostRouteItem,
} from '@aloft/toolkit-shared';

import { SubjectPropertyDataState } from '../../../../redux/types.ts';
import { AlertDefinition } from '../../types.ts';
import { getAlertTriggers } from '../utils/alertTriggers.ts';

const MESSAGE = 'Subject ARV condition is lower than the AIV condition';
const TIP = 'The renovations are expected to improve the condition rating.';

export const arvConditionBelowAiv: AlertDefinition = ({ order, propertyDataEntities }) => {
  if (!order.hasArvOption) return [];

  const subjectData = (propertyDataEntities.subject as SubjectPropertyDataState | undefined)
    ?.subjectData.editableData;
  const aivCondition = subjectData?.improvements?.uadCondition;
  const arvCondition = subjectData?.arv?.improvements?.uadCondition;
  if (!aivCondition || !arvCondition || arvCondition <= aivCondition) return [];

  const targetCellKey = 'subject-editableData.arv.improvements.uadCondition';

  return [{
    type: schAlertType.enum.arvConditionBelowAiv,
    status: schAlertStatus.enum.active,
    severity: schAlertSeverity.enum.error,
    orderType: ['appraisify'],
    message: MESSAGE,
    propertyID: 'subject',
    triggers: getAlertTriggers({
      fixRoute: schPairedCostRouteItem.enum.features,
      order,
      includeUpdate: true,
    }),
    fixingInfo: {
      tips: TIP,
      pairedCostRouteItem: schPairedCostRouteItem.enum.features,
      fixingMethod: ['action'],
      commentAlwaysRequired: false,
      targetCellKey,
      targetCellKeys: [
        'subject-editableData.improvements.uadCondition',
        targetCellKey,
      ],
    },
  } as Alert];
};
